// https://segment.atlassian.net/browse/INT-581
// Workaround an unexpected behavior in `analytics.js` where changing userId
// via `identify` also changes the `anonymousId`, which breaks our ability to link
// userIds together via anonymousId (needed due to userId reservation).
// This hacks around that behavior by saving anonymousId to a local variable,
// call `identify`, then set the anonymousId back to the original anonymousId prior to calling `identify`.
export const identifyUser = user => {
  let anonymousId = null
  // We also need to protect against `window.analytics.user` is not a function
  // Not sure why needed, but see https://github.com/segmentio/app/pull/2206/files#r74857096
  if (typeof window.analytics.user === 'function') {
    anonymousId = window.analytics.user().anonymousId()
  }

  window.analytics.identify(user.id, {
    created: user.created,
    name: user.name,
    email: user.email
  })

  if (anonymousId) {
    window.analytics.user().anonymousId(anonymousId)
  }

  window.analytics.track('User Logged In')
}
